/* ==========================================================================
   SearcherFli > Client > Product > Flight Hotel
   ========================================================================== */

/* Modules */
const Toggle = require('@bluekiri/alexandria-contrib-components/components/toggle-rxjs/client/js');

/* eslint-disable */
const ToggleActions = require('@bluekiri/alexandria-contrib-components/components/toggle-rxjs/client/js/store/actions');
/* eslint-enable */

const { actions, types } = require('../store/actions');
const configuration = require('../config');

const { ROUNDTRIP } = require('../product/constants');

function initFlightHotel(instance) {
    const panel = instance;

    if (!instance.config.endpoints || !instance.config.endpoints.crossSelling) {
        return;
    }

    /* Selector */
    const { selector } = instance;

    /* Reference */
    panel.crossSelling = Toggle(
        `${selector} [data-component='ToggleRxjs'][data-type='${configuration().type.crossSelling}']`
    );

    /* Actions */
    panel.actions = {
        ...panel.actions,
        changeCrossSelling: payload => instance.store.dispatch(actions.changeCrossSelling(payload))
    };

    /* Update UI */
    const updateUI = () => {
        const { product } = instance.store.select('data');

        if (product === ROUNDTRIP) {
            /* Show */
            panel.crossSelling.element.classList.remove('is-hidden');
        } else {
            /* Hide */
            panel.crossSelling.element.classList.add('is-hidden');
        }
    };

    /* Reactions */
    panel.reactions = {
        ...panel.reactions,
        changeCrossSelling: panel.crossSelling.store.subscribe((_, action) => {
            if (action.type !== ToggleActions.types.TOGGLE) return;

            const { checked } = instance.crossSelling.store.select('toggle');
            instance.actions.changeCrossSelling(checked);
        }),
        crossSellingProductChange: panel.store.subscribe((_, action) => {
            if (action.type !== types.CHANGE_PRODUCT) return;

            updateUI();
        })
    };

    /* Start */
    updateUI();
}

function destroyFlightHotel(instance) {
    if (!instance.crossSelling) {
        return;
    }

    const panel = instance;

    /* Actions */
    delete panel.actions.changeCrossSelling;

    /* Reactions */
    panel.reactions.changeCrossSelling.unsubscribe();
    delete panel.reactions.changeCrossSelling;

    panel.reactions.crossSellingProductChange.unsubscribe();
    delete panel.reactions.crossSellingProductChange;

    /* Reference */
    panel.crossSelling.actions.destroy();
    delete panel.crossSelling;
}

module.exports = {
    initFlightHotel,
    destroyFlightHotel
};
